<script setup lang="ts">
  import { ref, watch } from 'vue'

  const props = defineProps<{
    modelValue?: string
    readonly?: boolean
  }>()

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
  }>()

  const color = ref('#ffffff')
  const showMenu = ref(false)

  let isInternalUpdate = false

  watch(
    () => props.modelValue,
    (newVal) => {
      if (typeof newVal !== 'undefined') {
        isInternalUpdate = true
        color.value = newVal
      }
    },
    { immediate: true }
  )

  watch(color, (newVal) => {
    if (!isInternalUpdate) {
      emit('update:modelValue', newVal)
    }
    isInternalUpdate = false
  })
</script>

<template>
  <v-menu v-model="showMenu" :close-on-content-click="false" offset-y :disabled="props.readonly">
    <template #activator="{ props }">
      <div
        v-bind="props"
        :style="{
          width: '32px',
          height: '32px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          backgroundColor: color,
          cursor: props.readonly ? 'not-allowed' : 'pointer',
          display: 'inline-block'
        }"
      ></div>
    </template>
    <v-card>
      <v-color-picker v-model="color" :disabled="props.readonly" />
    </v-card>
  </v-menu>
</template>
